<template>
  <v-container>
      <v-card elevation="0" class="px-2">

        <!-- Title -->
        <v-row text-xs-center>
          <v-col class="text-center headline">
            HawkSoft Component Styles
          </v-col>
        </v-row>
        <v-row wrap class="mt-3">
          <v-col cols="12">
            Colors:
            <v-simple-table class="ml-3">
              <template v-slot:default>
                <tbody>
                  <tr v-for="(value, key) in colors" :key="key">
                    <td>{{ key }}</td>
                    <td :bgcolor="value">{{ value }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-col>
                Font Styles:
                <div class="ml-3">
                  <div class="headline">
                    Headline
                  </div>
                  <div class="title">
                    Title
                  </div>
                  <div class="subtitle-1">
                    subtitle-1
                  </div>
                  <div class="subtitle-2">
                    subtitle-2
                  </div>
                  <div class="caption">
                    caption
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row wrap>
              <v-col cols="12">
                Display Field (Mobile)
              </v-col>
              <v-col cols="12">
                <DisplayField label="Example Label" value="Example Value" />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row wrap>
              <v-col cols="12">
                Small Table Card (Mobile)
              </v-col>
              <v-col cols="12">
                <SmallTableCard
                    title=" Example Title"
                    :items="[{ name: 'Test Description', money: 10000, date: new Date(2016, 11, 17) }, { name: 'Test Description 2', money: 9900, date: new Date(1995, 11, 17) } ]"
                    three-column
                    :headers="['Header 1', 'Header 2']"
                    :fields="[ { name: 'name', type: ''}, { name: 'money', type: 'currency'}, { name: 'date', type: 'date'} ]" />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
  </v-container>
</template>

<script>
import DisplayField from '@/components/Shared/DisplayField.vue';
import SmallTableCard from '@/components/Shared/SmallTableCard.vue';

export default {
  components: {
    DisplayField, SmallTableCard
  },
  data: () => ({
  }),
  computed: {
    colors: function () {
      return this.$vuetify.theme.themes.light;
    }
  }
};
</script>
